<h1 mat-dialog-title>File select</h1>
<div mat-dialog-content>
  <mat-table [dataSource]="files$ | async">
    <ng-container matColumnDef="url">
      <mat-header-cell *matHeaderCellDef> preview </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <img [alt]="row.name" height="50" [src]="row.url" />
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> name </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="['url', 'name']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['url', 'name']" (click)="select(row)"></mat-row>
  </mat-table>
</div>
<div mat-dialog-actions>
  <button mat-flat-button (click)="cancel()">Cancel</button>
</div>
